webpackJsonp([15],{

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(51);





var token = window.sessionStorage.getItem('token');
//console.log('axios'+token);
var HTTP = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({

  baseURL: "https://v2api.omminiprepago.com.br/v1",
  authorization: "Bearer " + token

});
HTTP.defaults.headers.common['authorization'] = "Bearer " + token;
// Add a response interceptor
HTTP.interceptors.response.use(function (response) {
  // Do something with response data

  return response;
}, function (error) {

  if (error.response.data.error == 'token_expired') {

    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
      name: 'Login'
    });
  }
  // Do something with response error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_good_table__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_good_table_dist_vue_good_table_css__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_good_table_dist_vue_good_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_good_table_dist_vue_good_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_localforage__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_money__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuefire__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuefire__);







// import the styles 








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_localforage___default.a);
//Vue.use(Vuetify)


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_good_table__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_v_money___default.a, {
  precision: 4
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    primary: "#F69F00", //    "#932C28",
    secondary: "#F69F00", //    "#0097e6",
    terciary: "#E20612",
    carregando: "#EA9F12",
    acent2: "#932C28",
    errror: "#F50057",
    info: "#80D8FF",
    sucesso: "#00C853",
    card: '#E3E3E3'
  }
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08098bfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(118);
function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var normalizeComponent = __webpack_require__(103)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08098bfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 116:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('span',[(true)?_c('v-navigation-drawer',{attrs:{"temporary":"","app":"","disable-resize-watcher":true},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{attrs:{"to":{name:'Movimentacao'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("credit_card")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Movimentação Cartões")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name:'Lojas'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("map")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Movimentação por Lojas")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name:'Recargas'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("local_atm")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Recargas por Convênio")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name:'Convenio'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("card_membership")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Convênios")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name:'Promocao'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("money_off")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Promoções")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name:'Usuarios'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("people")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Clientes")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name:'Colaboradores'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("people")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Colaboradores")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name:'Mensagem'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("message")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Mensagens")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name:'Logout'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Sair")])],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),(_vm.mostrarMenu)?_c('v-toolbar',{staticClass:"toolbar hidden-xs-and-down",attrs:{"color":"primary","dark":"","fixed":"","app":"","height":"70"}},[(_vm.mostraSide)?_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{staticClass:"black--text"},[_c('img',{staticClass:"mb-5",attrs:{"id":"imgTopo","src":__webpack_require__(119),"alt":"Ommini Pré-Pago"}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"pt-4",attrs:{"color":"black"}},[_c('v-icon',{attrs:{"color":"black","size":"25"}},[_vm._v("person")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#000!important"}},[_vm._v("Ola,"+_vm._s(_vm.nome)+" "+_vm._s(_vm.getNome))])],1),_vm._v(" "),_c('v-tabs',{directives:[{name:"show",rawName:"v-show",value:(_vm.mostraTabs),expression:"mostraTabs"}],attrs:{"slot":"extension","icons-and-text":"","centered":"","color":"primary","slider-color":"red","grow":""},slot:"extension"},[_c('v-tab',{attrs:{"to":{name:'Movimentacao'}}},[_vm._v("\n        Movimentação Cartões\n        "),_c('v-icon',{attrs:{"color":"black lighten-3"}},[_vm._v("credit_card")])],1),_vm._v(" "),_c('v-tab',{attrs:{"to":{name:'Recargas'}}},[_vm._v("\n        Recargas por Convênio\n        "),_c('v-icon',{attrs:{"color":"black lighten-3"}},[_vm._v("local_atm")])],1),_vm._v(" "),_c('v-tab',{attrs:{"to":{name:'Lojas'}}},[_vm._v("\n        Movimentação por Lojas\n        "),_c('v-icon',{attrs:{"color":"black lighten-3"}},[_vm._v("map")])],1),_vm._v(" "),_c('v-tab',{attrs:{"to":{name:'Convenio'}}},[_vm._v("\n        Convênios\n        "),_c('v-icon',{attrs:{"size":"20","color":"black lighten-3"}},[_vm._v("card_membership")])],1),_vm._v(" "),_c('v-tab',{attrs:{"to":{name:'Promocao'}}},[_vm._v("\n        Promoções\n        "),_c('v-icon',{attrs:{"color":"black lighten-3"}},[_vm._v("money_off")])],1),_vm._v(" "),_c('v-tab',{attrs:{"to":{name:'Mensagem'}}},[_vm._v("\n        Mensagens\n        "),_c('v-icon',{attrs:{"color":"black lighten-3"}},[_vm._v("message")])],1),_vm._v(" "),_c('v-tab',{attrs:{"to":{name:'Usuarios'}}},[_vm._v("\n        Clientes\n        "),_c('v-icon',{attrs:{"color":"black lighten-1"}},[_vm._v("people")])],1),_vm._v(" "),_c('v-tab',{attrs:{"to":{name:'Colaboradores'}}},[_vm._v("\n        Colaboradores\n        "),_c('v-icon',{attrs:{"color":"black lighten-1"}},[_vm._v("people")])],1),_vm._v(" "),_c('v-tab',{attrs:{"to":{name:'Logout'}}},[_vm._v("\n        Sair\n        "),_c('v-icon',{attrs:{"color":"black lighten-3"}},[_vm._v("exit_to_app")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-2",attrs:{"dense":"","color":"red"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","py-3":"","text-xs-center":"","white--text":""}},[_vm._v("www.grupotecnoweb.com.br© "+_vm._s(new Date().getFullYear()))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAAAqCAYAAABvAA/nAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAK8AAACvABQqw0mAAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDUvMTUvMThRm6g2AAAgAElEQVR4nO18eXQUVdb4fVXVe3e27ixkT8hCSNgSZJVNUWEQBAdkUUcRHAZUVHD9ZsYFQUQHlQFHQRY3FBUXBAmLIBIICQHCln3vTjrpTu9LdVd1Vb3fH0nH7k4H5Tu/+X3f75y559Q56ffeXd697913761XQRhjuBnY//U3T44dO/ZdkiShqanxiUmTJ227KQL/gX8LEDeLIJFKbpHJZODxeMBms3b9O4T6D9w8UL9nUOKghIgVf1nJvvzyy16VUpUnFovB4/XgK1evdc+eMweGjyiIvHrluv1GNJYsXhQ78w+zZkokkigsYAERBOFyOQ3Lli3bjzHmf6/Ai5fcHztzxow/SKWSSCxgAQMQNqu1euWqlScxxsKYMaPlq1Y9Plcul2uwgAVAiPB4PNavvvzi28PFR9y/lw9CSLZz5867lQplPAAAQRCki3a3Pfboowdpn4/fvn3HlKioyJGAgQ9EMptNP65atar56aefSi0qGn2nWCSWYcDA8wJbXX395/XrN9TfgCfasX3HjKio6CG8wLMIAQBGiBd4rr1d9y1CQKWkpM1HCAkAGAMGBAgwRVHsDQ3517/+dfzECbcu+vzzL++oqr6+HCF07kLFhVhBEIBARPvpktOV//pXdP4/3npn/4+HfvzpxMmTO95+e/O1UDrvvLM5YeXKx35OTU0bIpFIQBAEIAgCnE4nHPzh4EYA+K/fo9xNb2xKe2zlyqMpKam5gXQMhi7Y//X+aQihkqNHjx3KzsqeJpPJQBAEQAQBjNcL8XFx9wDA/N/DZ8aMu9QnT/78bUpyymSFQgEYYyBJEux2O3z40UdrEELvXLt2/RONWpMqCILfCAAAcOZsiXnlylXuh/700OnEpMQ0ESUCAACe5yE7K8uw7rV1k176+0sN4fiuXbsmftSowv3p6elylmUBAIAgCHC73aDVas0FBQVTC0cVrkIIgf9IRAiB1+sN71pXrPxz1MGDhz5cvGjJicLCwtXx8fF5PoatefbZZ0dIpbJYnudBEITmY0ePOtRq9cTcnNwhhYVFjz/4wAOnP/vss6dD6SUOSl6VnZ0zJCIiAiiKArFYDBRFQUJCAiQmJq1avnxZ4m8pFyFETpw4ce/Qofm5KpWqj45YLAa1Wg3xCQnqf767ZcLgzMHT1Gp1X7+IoiAqKgoyMjP/uGHDhpG/w46wevVTm/OH5k/WaDQgEolALBYDSZKgVqshMiKyYO7cezJVSqXaz18sFoNUIgWPxwPGbuP526ZNezAtLTVNqVCCSCQCkUgEMpkMMjMHx0+/7Y43kd/qIVBQMCxeo9HICYKAINpSqbOmpvpafHx8gVgs7pOpR48kNDTUt/Qz5Ntvvz126UPLzo+5ZczyxMREmVwuB5PJ1PzUmqetmZmZIxUKhZTjODAYDXoAgJhodaZcLgeJRALp6RlR48dNeHvvZ3tXB9KMiYnJBwDgOA4wxn2Pz+eDmJjoyKlTp93+W8r96uuvn01Pz5iIMQae5/toAADQtAfKy8vc+QUFoyIjIoFhmCA+HMeBUqGEvCF5i36Lz65du+7Oysp6iKIo8Pl8QXQEQQAM+OLYMeOG+3ycAmPo60MEAovF4ljz9FOW3NwhuQRBBsnp9x4ajeaerdu2TRyAfYFEIumH53I5TZ988klXTHS0BiCAJ0LgdtNCZ1fX9iBDbli/fszUKVOLc7JzsimKAkEQwOv1Au2hawEA4uPiUwmCAIwxGA2GJgAARKA8ihIBz/PAcRyo1WooLCzc9PrrG/MBAORymVQml6eQJNlPap7nISIiEmJiYubeSLmbNm0aOiR3yN8VCgX4XZkfEEIg8IL3wsWKbgHjAoLs72QwxiCRSGDQoMRpIrFYMRCfefPmxucPzX9fo9YAzwcf2wRBAE3TYLPZqnOHDEmgKAoAgiN+hmWbWJYjEUK5IpGoH32O4yAmJgYVDC14KRx/mUw+IjSLQAhBd3d35+LFi3MwhmSC+HV+PW7XxXq9ntK+1oeXPqScPHnKp2lp6dGCIPScLwgByzJAkWQJAIBSqcyhKAowxsCwbHlWVoZYKpEUBE7Ix/kgMjJKWlRYtBIAYN6985IiVBFhDQnQo+TUlNTJCxYsGNC9jh0z9v34uAR5qHIBAARBAJIitd9//71eJKJGDOC1QCQSgUqlLHr1lZeHDMTn0eV/fjU1NS05XEpGkiTY7Db+6LGjbWmpqbFisRgCxwmCAGIRdS0tLVXB8VxeoMIDgUAEJCUl3rF9x44ZoX2xGk1qOPldLldV3tChSYIgRAS2I4SApj3ma1evdvdxm3P3PS9kZWXnAEDQQcowLNjs9loAAKVSWSCTycDhdPBut+va1Cm3ayIjo5KCJo4BxGIxaDTqsQghyM7KjaZElGYgBQMAqFQR6mnTwrvXffu+fCIjI3MySRIQTsE8zwPDMG1eD2ONioxKHygv5nkeoqKiyKF5+bPC9b+37b3ZWVnZK/xBUjhgGbbz2LHjPpZhC8VicV87QRDAMAw4nc7m+fMXSMQisQYGSM95gYeoqCgYOmToS6E6iY2NSwi34BGg8vyCfFno4un5E7ft37+/kwAA+OO9f4zLzs79i1QqDZoExhg69B1lb775xokVK1akyWTyLIlEAlaL1X7i5En3wUOHjBar5edQgUiSBISIIbdOmhiXmpISTSBiwOgYYwxSqRSNHDFqemjf8889l503JG99RETEgMoVBAG6DIbOJUuWRMXEqCMGMqQgCKBUqiAyMqqfG58+bVrUmDFjN6vVauA4biBRARGoUR0TI8YIRpAkGbTgaZqGpqamprvvni1VKBUg4PDyAgBQlAgGDRo0fs+ej+71t40ZNzaBoqi0HpfdA/6ItcvQpUtLTk2Uy+UhXoAHkUjc2GUw2AkAgPnzF9wXGalSByqLJEkwmUxQUXF+eXn5eWfekCHRDONFRqPRa7fbz/1y+herwdDFeb2e0wzDQKgxCYKQpqSkxsTExOTL5QOv8l5DgkQimfbAAw/EB/bdeeddmxMTEyNupFyMMVgs5rpRo0aNBADJjSpVPM9DYmLi0NdeW18U2L56zZq/JScnZw+E13PEsEC73boRI0dguUyeHDpfjuNwbV1di8fjGS0RSwacb+9Y0GjUkJU1+EV/BDvzrpmZvMAnBdIlSRKcTie+ev2awLDsLSKRqM+QBEGA1+sFi9ViAAAgEEJETk7OJIVCGcQcIQRms/mXZ555pgoAwONlqo7/dHzcx598dOvJn088Yu428QAAPMeL/BFUiIp9HjdNRUVFZ8lk8rBuMVDBMTExKbNnzx7lb/vo44+XZ2YOnj3Q2donJ4HAQ9MXByUMGgYYBvbf0GN0hUIhychI73Ovmze/PT4nK2dNqDcK4oFQb2rRfe0PM2ZhuVwuCtUVQRK2M2dPd2EsTKWoMO4xRD88L0BSYvLo9z94fzEAQG5ujkZE9Y+QWJY16PV6G4GIYYE0EPQsrvZ2XQcAALVk8ZI0nudHkyTZNxGCIMDlcgHDeH/0G+DFF1/wAUC/ZF8qk0X5Q+ZAhfG84LDYLRxJkVkURd3QZfVErxGgVKjuA4Ajjz/+RPojSx/ZGBUV1YfnDx4CFegvKjQ0NVbfcfv0uwmqf4ARmDz7o9fMzMF3AMA6hBCcKy3bFhcbh4L5IBCEoIINcBwHer2+OS4utjBcoONyucznyysMERGRWQRBhi4KzDBeJBZLgnBUKhWMGD7yaQD4PDUlLUoul/c72kiKbGa8XqtSqQgKwjBgwBhjQ5ehHgCAmDxlcoJCoQgKWPzVgqrq6uYBtd8LHOcbErraeiPe+tOnSswUSeWE9ocLfDDGkJqWOhEAYO7cuRtTUlI0/sVBEAR4PDS43C4IdT1Wq9X6yacfcZrY2GSJWNJv56OQTSoSiUClVBUmJyXHf/ftd08kJSUV+jF6+HjA6QxbbeQbmxr0Mql8qkQSzIfneTCbza0YY1dUZFRcGFzvL7/88oXVZmUDz0CSJCEuLm70pjc3TaFpOlUcIr/P5wO3y60bPmwYpVSqlGFSL5tOp2sEACDkcvlspVIpDuNWXA2N9Tc05IwZdyoVCkVuCHHw+XwgCELdrFl/ECmVyqTQXdTZ1WnT6XRNgZNCCEFUZGTCjh0f7swanHWPP5ggCAI4joOrV69+46E9LaGLwOv1NknFUoXAC0MC3TBFUmC32+2Vlys7/akUQM8ii4yMlP9z6z83ZGfn/F2lUvXtPoQQXL5y+VhTU9O1QFoYY3C73dazZ8+0RkZGDg4MdPz9NE3XPvDA/YkkRQYZsse7OcUlZ0o2WK3WH3w+X58sHMeBOkYNI4aP/CvH+24L5OmPhA2Grvqk5ORRFEWhUJ5Wq9V++dplIwAAER0dvUQmk/UbhBDqPnv2jPZGhpww8da0QQmJyaGLgOM4aGpuap41a3ZGdHS0OPQ8cdgcV1q1rZtdLleQy5RIpBGz7569TKlUyvy7ESEEFoul4dCPh/YoFIrIoEwHYyBI8kp+fr4MY5wRaGQMGDiO0504eeIVAGD87TzPg1wuhwnjJyyLj4+P9fl8ANATSRq7Da5LFy+sj4qOjgjMAzHG4HQ6tRcvXOpURagSwunC6/VUDx8+YgxFUsrAdpIkwWw20w6HrfvSxYvveTyeIK/CcRwU5BfcUZA/bBoGoV9Uqu/U12vUscNDY4UevZg7Sn4pcQAAEFKpXBR4jviVyrKs8+KFS+ZwQvshPTX9drFYLA51yxzH8VVV175SKhSjSCJYAIwxMD6v/ccfD12kPTQbdIAjBIGRGUmS4Ha7oKr6+l+LikZHcxwX4x/ek+MywDJMw9RptxNSqVQSZjEyu3bt/MpkMtlDDUNRwRGgx+OGhvqGd11uWqdUKFNDzyqP16OdMmVyHEVRQdUVkiTB5XKBqdtUnZ6ekR6YX/rB4/F0fPfdAfvKVStPtXe0nw2VRSqVglwuDy0UASIIQattq42Pj8vwV9SCZPJ4GnBvI8F4vbHhzjCSDFPrChmTlzf0j6GCkyQJBkNX47p1rzWpVKoRvYdyHw7H8eB20W27d+2+7LA7GkJ3c+BYQRCgpaWldP78+V9nZ2VlBp8vBNC0Gxoa6vXD8vMHhZbvOI4Ds9lkNhqNtm5Td0lopSVQKQRBQHt7e/uce+ZsGDZs2EypVNrPQ9E0XTtu3Lh8qUQaG3jsIoTA6XT4fjjwfWViYqKapMiQTYGBF4QmmqYZAIC62trXrVarEDiXwLpxINBu2nmkuLgjOjo6NnTBC4IAGOOqX+dAEt2hBAiCAIqiBr/44gtT+lHvhc8//3xtXFzsJH/Jzo/ndrvBbDb/CwBArdEMJgNC8R5DsiASURcxxmybtvVngQ8f8lMUBQajgT1bWvoMAIBCIc+RSH6NFjFG4PP58PWqa62szzdBLBb3GRIhBDzPg9Fo1AEA2O32QzabDcKlMhRFgclkgpqammcxxl6FQjEyMBXx11gddntlTk5uAiWiEMKBSiWAYZjOo8ePkwjBUP9rK78cDOsFr8fT5m9btnzZ8Y6OjrPhyo2BgBACu93eIpXLpD4flxMoe29+CTa7rcPfRphNpj2BZxVAX0Agu+++hR99tnfvw2ufWVu04L4Fg/+8YsWwnTt3zThx4uSusWPG/kOlUqFAgRBCYDQaOz/+7NO9UplYpFFr4igypFLhcgPDMLUAAHq9/iuTxRS0OvvGud1QW1v73osvvnAuPSM9kvVxwwPdIQAGgiDN586V6cVi0S3hdpzd4agFAPjmm69P0TTdHc7zsCwDTc2NPzz08EP7AAAiIyMHBW4OgiDATbuhuaX5fFJSUixFUYAhcLcKwHF8Y17eEDVFikaGJu202w1Wq7Xq1/HYd+HihU1WqzXswgoEl9vZNOnWyWkURSWF7kiH0yHoO/Q1fXLWN9R9bLPbzOG2elpqevqEcRP3PPynpSWvvPTqmScee6Lk1om3Fg8fNvyRqKho4AN2E0VR4HA4oL6+7uWv9u0z33ffosEAMChQwQghoL207+q1qzQAwJNPPllutVjqAPqX+LRabd3OHTteBQBYuOA+tYiiMhEKXmweD205f/68ISoyul+xGWMMLMNUAQB88smnrcZuY1lgxOjnYzQazeXny1f2yieRyWSJBBGsNJZh6fKyMiyiRIWBKY6/uuJ2u2tHjBhJSKXS5ND5sqwPzGZTUPS/Zs3TxVqd9tiNiiSCIADDMDVDcvNixGJxv2OO57iukjOnO/2/iXXrXmtw2B2HWJbtl99xHAdRUZGQkpwiS0xMTEhOTo6Mj4/vc12BCvF6vVBdXfXpwkULPwQAGDViVBYAjglVriBgXfHRYmPvb9ZgMOxzuZwgkUj6Xga3t+uEyspLjxUfPWIHACgsHC1XKJRBr594ngeT2dQCAIxSqYwJTXGsNhtjNpv0/rbqqqp9Ho8HRCJRHx+bzQrV1dUvvPzSy3oAgOWPLs9QKhTpoR6CZdl2q80qkysUw0NzSIZhwOV2VUyZPMUnkUjEocbBgJ0NjU2dQW0YCxcuXHjDZDJxobz88nu8HrDZbdWpqamK/sVyDBhj3eHDxQ5/GwUAcPTokVcUSvmd6WkZgwiCCDISz/PAQ3h/7ncNHo8Hrl2/tm/Rovl/djhpAABIT09PlEql/RJniqJqz509Z/S3/fzzifdlMlm2VCbLAIw5AQusXq/fveqxVSf8YyQSSUbPW4lfUxIAAKfTVbV27drhCKHY0OsPTru9+9y5c33pU3lFxTepqWnjlUpFoYCxDwDAbDYfWbR40e6FixYCAEBmRkaSRCKJ9tP311i9Xu91jvO5xSJxauj7QJ/PBzqt1pgwKGGUVBpcYxUEATxuT/e1a1eDDAkA8MILz58qKiw6HB0dPSdMnRpotxtaW1q1GnXsgkBD+os1Nru9FWPsCTLkhtc3tG7+x+Z7x49nPk5NTcvpSZKFfi9X/YQIgugpj7mcYDQau2prat5Zcv+SN/1GBACIjY1L9tdvEUJ96YLD4dDhAOtu3fZeNwA8iHr8JsZh/I2P8030R8eBk6Zpd82QIXlFFEWRfh6Aew3gY1p/OHjQ6h/78Ud7GAB4ws8H/MwC2CUnpSQSvW+m/fP0eD3AC/yFolFFrEQiVgtCcF1ZEHi+uqbampWVtdB/vycw4Xe4HK0nT57sW7h+wBjjV195ZUNi4qA5SUnJ4PeIGGMgCRK8Ho+zsvKSe8rkqeOlEilwPNcnE8uyYLPZaoOM7/9j7TNry558+smJFy9dfO7KlcsVOp2OdTqd4PV6gWEZYBgGvF4v2O12aGtrpS9fuVx+6dKlv23dtmXSkvuXvBkqKMuyozHG4GW8fY/H6wGttq0jdGzvxIRwRgQAkMlkRRjjHlkYL/g4H9hsNujqMlwblJCQhnHPTQYv4wXGx4Db7QaGYevCkfPzCcdLoVAO9Z97XsYLDMMA4/VCV2encVRR0UiKosDLeHr7vL3uz959vux8jUgsyuc4PhiXYcButw1YHXv5lVfOV1VXb+ju7gaO8wHDMODjfKDv1ENDY+Mb+/d/00CSZAHjY/p06KdrMZuaAmkFOeiK8xUmAHgLIfTu+vXrkzUazW0xMTHDCYJIQQjRDMN22GzW8nadruz1jRuNGGNuzpzZYYXUatu+tDts7QIv9Gx/BAQvCFxTc9NnA00MAGD79u1JmZmZQ7///vuS9957zwsAYDQYPjl/vrxJEAQGADBJkWK3y21Zs+bp8t279yg9Hk8sQsgDAIAQIgQsiLq6unbeBXfdiFU/MJm7T165elkNGLwYY0wQBMX6WG91dfWR+IR4uHrt6hYRJaKEHh+PEUIKm912pvJKpW3Xrt27aDfdIvC8BwMAIggCC5jQalt33ojnggXz//bhjg+r1Rr1FADEYCyIuo3dx/6y8i/fDR01FjU0NrzW1dWZxvM8CwBAkKSYZVlrQ0P9j0GE/BHq/4bn9ddfj6yrq+ssKytrW7Vqlex/Wp7/n57fdUH5/xVMmjTpHwAQo9Ppct977z3PbyL8B/rgf5UhaZr+6cSJE1tXrlzZ+j8ty/8t2LFjx1CJRJLh8/lcP/300/l9+/bd1AJ9//33NVKpdBzHcR2PPvpo5YAD/VsTAFBZWdkHTU1NRp1OZ9JqtWatVmtub2+3Xr169fyJEyf+BABkuG1dVlb2D5/PZ8AYczgY+Jqamus//vjjrIFcwpkzZzY1NjYatFqtqaOjo769vb1Fq9WadDqdqaWlxdPQ0LD6v+tuNBqN+OLFi983NTV163Q6c+CcKisrTxYXF8/+LRoAQFZXV++iadpQXl7+9O/hCwDohx9+eFSr1XbabDbc0dGBjUYjdjgcbFlZ2dYVK1YofovG3r17p9XW1p7zer24vb0d22w2bDAYHKdOnXq+sLAwInR8X3EYISTRarVnk5KSimpqag6KRCIeAASfzxeRkJAwXaVSQWlp6TNTp07dHLoYqqurP4uLi7ufYZh/JiUl9V2H12q1qQqF4lmSJOHbb7+d+sgjj/wSitvY2Hg8KytrenV1dTFFUQz0RtIY9xQ0JRLJjvT09EM3s4r9kJiYGHf9+vXLSqUyqq6u7qhEIkEAwHEcF5+SknIrSZJw/Pjxhffcc89XA9HYtm1b4vz58zvUajXo9XrdO++8U/Duu+86BhoPAHDlypX/Gjx48Aa73d7udDpf7+rq8kRHR1MRERFzYmNjZ5tMptMZGRlTsV/5IXDgwIGHJ0+evMfj8XicTufrer2+IyMjgwKAxXFxcdP0ev3P2dnZf8AYe/uQAlaRpK2t7TLP8/Wh1v7ggw/SHQ6Hoa2tzbV69erI0P76+vpPm5ub8YwZM3JC+w4dOvQni8WCW1padodbefX19ccFQej+dwQAgwYNijUajRafz3ckdJcdOHBgtMvl4urr62tuRKOkpGRdZ2cnPn369FtutxsfPnx4QO+CMYbjx4+PdzgcuL29/frkyZMTQ/svXrz4rtfrxceOHXs2HP7WrVvzDQYDazAYjGvXrs0L3elXr179u9vtxpWVla8F9QUasrW19QrGOOzETp8+/RPHcdhqtcaF9tXV1X3a2tqK33rrrbGhfWvXri3U6/UYY/x5OLp1dXU/YYy7/l2GNBgMVozxodA+AIBLly418TzvGAgfACiTydRpMBiO3nnnnWqdTuepqqo6diOe58+f/9Lr9eLdu3dPCNe/evXqpFOnTl0/fvz42+H6GxsbX/V4PPi77757cACZxAaDoUmr1drXrVsX728P984x7HsljUYT7XQ64dy5c/3cgf/92KVLlyyhfePHjy+SSCRQXl7eGo4uQghjjMUIIRVCSIYQkvc+SoRQ/3v3Nw8IoH+NEWMMkZGRSpvNNuCtsK+++upOn8+X0NzcfOzo0aNmAPg+OTn59scff3zA2+q5ubm3tbS0tD7yyCPnwvVv2bKlY8qUKQXTp09fE9o3btw4KcdxDzEMY5k7d+6n4fAxxmxlZeVhjUYTce+99/Zd4QyKWgmC8Pl8vvhNmzZNUqlUPM/zPEEQETNmzLg7Ly+vsLq6+syLL75onzlzZhBxlmV5jUYDL7zwwrrLly/rCYJAHMfhpKSk6KlTp97ncDjKP//883+OHTs2nGBejHF0c3PzJYIgWPj1jCRZlu168sknF2/ZsiVsNej3AEmSDE3TqRs2bBgfFxeHfD4fp1Qq42fNmnVfZmZmXEVFxWcxMTFhcceOHTtXoVA4du7cuWfcuHFQUVHxxYQJExatXr16FgDUho5/6aWX1OvWrVPpdLoy7N/2ALBt27aMxMTEu0mSJBBCgtvtxjRNX162bNmZQPy5c+dKVSpVWltbW8Xw4cMHnJNGo9knk8keNxqNE/Pz888AhBiS53kXSZLxy5YtO+2vF2Lc821gZ2dn1eHDh1ddvnyZDSXMcRwvl8shMTFxEcuyAkKIwBhjsViMxGIxHDt2bO+WLVvCft2MMQaCIHwkSTp9Pp8QULAWcxzncTqd/fiVlJQMnjRpUp/2LRYLVFRUNN111139PIIgCBaRSDTyscceK/UXvDHGQFEUtLW1ndmzZ88Lt9xySz+5Nm/erFm4cOHDer2+ymKxSB5//PGM5ubmujlz5nTTNP0XgiA+EAQh6MNZmUyWwfO8hCRJOrA9JSXlwby8vFf9xe+IiAigabouJSVlok6n67tOIxKJACEkCILQb86BkJmZaQEA4Hm+z2MFGbLXpXV3dnZu5DgOI4SAoihCq9Wa586d+zXGmA4l2jsBqru7G/bt23f/lStXzkdHR4vsdrtvwoQJWXPnzt00a9asN998881vn3vuuX47CyEkAwBLampqYTjau3fvDtf8IQBM8/8QBAHcbveDABCu/BeBEKrT6/XbBUEQEEKIJEmyoaGhfdGiRV8GbJwgyMnJuTspKUlkt9tHbtq0qY0gCAJj7EMISePi4mL3798/FAAqAnFKS0svEwTh4jgus3cxCwAAjY2NH9lstjqEEO/xeISlS5e+ihAaBABBb5bPnDnDz5s3zxMbG5sWVqheOHXq1Px58+ZBenr6xb7GkGDnKsb4+s0GFXV1dZ+2tLTg9evXjwjtu379+sM2mw3v378/bA7WG+wYb4bf6dOn4zHGmf7HYDBk7tq1Sz5AsGPHGH97s3PS6XQVTqfTXVpa+tW5c+e+KCsr+/Ls2bNflJSUHKJpGldUVHwUDq+6uvq8xWLBK1as6Bex+h+Hw3HRZDJ1JycnBwWOAICqqqq+ZVmW37hxY+5A+LW1tUc6Ozvx/v37B/fhhhjyCsa49r9jyN6odVxo3/79+2e2trbiw4cPv3QDQ/67o9bDN4O3fv36MSaTCbe0tOwI7QMAorW1tdnpdFoWLFiQENp/5MiRxTRN46ampg/D0S4uLv4TTdO4u7u7IdSQGGM4ePDgNIvFgmtra08DABXa//XXX9/h9XpxXV3dIej91gXj/lErgn6X8n4bSJJEPV9g9b9C3t7e7hymOosAAAI4SURBVCNJEnJzczUDoGMAkHd0dBQBwLDAh+O4YVarNfZm5fFDrzg3NSeEEFq6dOk9EokEiouLv+0nLMYCx3Gf8Twf/cQTT/T7nwQzZsz4QqfTfZOcnLy8trZ2V3Fx8ZB58+Ylb9++PbuysvLvRUVFHwMACIKASJLsp6/Zs2efbmlp+TQ1NXVSTU3N92VlZXn33ntv8tatW7NKS0vXTJ8+/ZjFYuk6cODAUxjjvvu6gWckRxCEl+M4abjrBzcCs9lMS6VSjmXZfnVEvV7fzvO8S6FQZAyAbgUAVVJS0oUB+l8FgFduSqBeoGmaBQCW4zji985p+PDhio6OjiUcx11duXLlkXBjdu7c+c1TTz31bHJy8l0IoW29OxUAejxcbGzs0qNHjxrS0tJWqdXqRzIzM80KhSJGLBYjnU73ktFoTMvOzh5HUZQrlDbGmEcILT937pwpIyPj6fj4+FkbN260yOXyyKioKNJisZSWlpY++uyzzzYG4gXd39Tr9VmRkZEShUJRFcrgRrB3795ElUoVW1paWvPGG2/0i7guX748lOM4GD16dHVoX2tra2p6enrY3cpxHDidzo7o6GjDzcjjB9Tz2Xa+RCJhVCpV429jACxdupScP39+3oULFxwvv/zygDftKysrCxiG4cePH18TqMNAOHny5HCVSvWgIAgLZTLZBx0dHQdmzpxZNWvWLNHzzz+fNnny5BvK9M033wxPTk6+A2M8heM4m1Qq/fiWW24pxxj3WwD/BxRaQFqVUl1OAAAAAElFTkSuQmCC"

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
// event-bus.js

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",

  data: function data() {
    return {
      drawer: null,
      menu: false,
      nome: window.sessionStorage.getItem("nome"),
      windowHeight: "",
      windowWidth: "",
      mostraSide: false,
      mostraTabs: true
    };
  },
  created: function created() {
    //this.menu = false;
  },
  mounted: function mounted() {
    var _this = this;

    // this.mostrarMenu();
    __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* default */].$on("mudounome", function () {
      _this.nome = window.sessionStorage.getItem("nome");
    });

    this.$nextTick(function () {
      window.addEventListener("resize", function () {
        _this.windowHeight = window.innerHeight;
      });
      window.addEventListener("resize", function () {
        _this.windowWidth = window.innerWidth;
      });
    });
  },

  watch: {
    menu: function menu() {
      alert(this.menu);
      //this.mostrarMenu();
    },
    windowWidth: function windowWidth() {
      if (this.windowWidth < 600) {
        this.mostraTabs = false;
        this.mostraSide = true;
      } else {
        this.mostraSide = false;
        this.mostraTabs = true;
      }
    }
  },

  computed: {
    getNome: function getNome() {
      var _this2 = this;

      setTimeout(function () {
        //return window.sessionStorage.getItem("nome");
      }, 5000);
      setTimeout(function () {
        //alert(window.sessionStorage.getItem("nome"));
        _this2.nome = window.sessionStorage.getItem("nome");
        //return window.sessionStorage.getItem("nome");
      }, 10000);
    },
    getShow: function getShow() {
      return window.sessionStorage.getItem("menu");
    },
    mostrarMenu: function mostrarMenu() {
      if (this.$route.name == "Login" || this.$route.name == "Index" || this.$route.name == "ResetSenha" || this.$route.name == null) {
        // alert('false')
        return false;
      } else {
        // alert('true')
        return true;
      }
    }
  },
  methods: {
    /*mostrarMenu() {
      console.log("antes: " + window.sessionStorage.getItem("menu"));
       setTimeout(function() {
        if (
          window.sessionStorage.getItem("menu") == "false" ||
          window.sessionStorage.getItem("menu") === false
        ) {
          this.menu = "false";
          //alert("é false");
        } else {
          //alert("é true");
          this.menu = "true";
        }
        console.log("depois: " + window.sessionStorage.getItem("menu"));
      }, 1000);
    }*/
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localforage__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_EventBus__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_http_axios__ = __webpack_require__(106);



var _this = this;





var Login = function Login() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 301));
};
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 302));
};
var Saldo = function Saldo() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 303));
};
var Extrato = function Extrato() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 300));
};
var Lojas = function Lojas() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 304));
};
var Movimentacao = function Movimentacao() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 305));
};
var Logout = function Logout() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 306));
};
var ResetSenha = function ResetSenha() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 307));
};
var Recargas = function Recargas() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 308));
};
var Convenio = function Convenio() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 309));
};
var Mensagem = function Mensagem() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 310));
};

var Promocao = function Promocao() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 311));
};

var Usuario = function Usuario() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 312));
};

var Colaboradores = function Colaboradores() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 313));
};
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
//Vue.use(VueLocalForage);




var routes = [{
  path: "/lojas",
  name: "Lojas",
  component: Lojas
}, {
  path: "/movimentacao",
  name: "Movimentacao",
  component: Movimentacao
}, {
  path: "/mensagem",
  name: "Mensagem",
  component: Mensagem
}, {
  path: "/promocao",
  name: "Promocao",
  component: Promocao
}, {
  path: "/convenio",
  name: "Convenio",
  component: Convenio
}, {
  path: "/usuarios",
  name: "Usuarios",
  component: Usuario
}, {
  path: "/colaboradores",
  name: "Colaboradores",
  component: Colaboradores
}, {
  path: "/recargas",
  name: "Recargas",
  component: Recargas
}, {
  path: "/",
  name: "Index"
}, {
  path: "/login",
  name: "Login",
  component: Login
}, {
  path: "/dashboard",
  name: "Dashboard",
  component: Dashboard
},, {
  path: "/saldo",
  name: "Saldo",
  component: Saldo
}, {
  path: "/extrato",
  name: "Extrato",
  component: Extrato
}, {
  path: "/logout",
  name: "Logout",
  component: Logout
}, {
  path: "/resetSenha/:id_token",
  props: true,
  name: "ResetSenha",
  component: ResetSenha
}];

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: "history",
  routes: routes,
  suppressTransitionError: true
});

router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log(to);

            if (!(to.name == "ResetSenha")) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return window.sessionStorage.setItem("menu", false);

          case 4:

            next();

            return _context.abrupt("return", false);

          case 6:
            if (!(to.name == null)) {
              _context.next = 9;
              break;
            }

            next({
              name: "Login"
            });

            return _context.abrupt("return", false);

          case 9:
            if (to.name !== "Login" && to.name !== "Index" && to.name !== "Logout") {
              window.sessionStorage.setItem("menu", true);
              __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* default */].$emit("menuon");
              if (window.sessionStorage.getItem("token") !== "") {
                next();
              } else {
                __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* default */].$emit("menuoff");
                window.sessionStorage.setItem("menu", false);
                next({
                  name: "Login"
                });
              }
            } else {
              if (to.name === "Index") {
                next({
                  name: "Login"
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* default */].$emit("menuoff");
                window.sessionStorage.setItem("menu", false);
                next();
              }
            }

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);
/*if (window.sessionStorage.getItem("token")) {
      window.sessionStorage.setItem("menu", true);
      next();
      return;
    }
    window.sessionStorage.setItem("menu", false);
    next({ name: "Login" });
    return;
    //.logado = false;
  } else {
    window.sessionStorage.setItem("menu", false);
    next({ name: "Login" });
    return;
  }*/

/***/ })

},[112]);


// WEBPACK FOOTER //
// static/js/app.808d4c62586cd813602c.js